(function() {
'use strict';

angular
    .module('TR')
    .controller('Home', Home);

function Home(
        $route,
        broker,
        occupancyService,
        publicityService,
        criteoService
    ) {
    const cm = this;
    const area = $route.current.area;

    publicityService.getStats({
        StatisticTypes: 'All'
    }).then(data => {
        cm.stats = {
            numberOfAirlines: data.AirlineCount.Value,
            numberOfHotels: data.EstabCount.Value
        };
    });

    occupancyService.enforceAreaLimits(area);

    // if we arrive at this route we must cancel any outstanding searches
    broker.publish('homePageHit');

    criteoService.enqueue({}, 'home', area === 'holidays' ? 4 : 2);
}
})();
